import type { MessageKey } from '../en';
import { account } from './account';
import { apps } from './apps';
import { chat } from './chat';
import { common } from './common';
import { help } from './help';
import { site } from './site';

// Every Hindi catalog, merged; the type makes a missing key an error.
export const hi: Record<MessageKey, string> = {
  ...common,
  ...chat,
  ...account,
  ...apps,
  ...site,
  ...help,
};
